import React, { useMemo } from "react";
import { useTheme } from "styled-components";
import EditableText from "../inline-edit/EditableText";
import { Error, Success, Warning } from "../icons/StandardIcons";
import {
  Container,
  IconContainer,
  IconTitleWrapper,
  Text,
  Title,
} from "../styled";

const ICON_BASED_ON_DESIGN = {
  warning: Warning,
  success: Success,
  error: Error,
};

function Standard({ data, isEditable, isTemplate }) {
  const theme = useTheme();

  const { borderRadius, accentColor, textColor, design, displayElements } =
    data;

  const Icon = useMemo(() => ICON_BASED_ON_DESIGN[design], [design]);

  return (
    <Container bgClr={accentColor[theme.name]} radius={borderRadius}>
      <IconTitleWrapper
        align={displayElements.includes("title") ? "center" : "flex-start"}
      >
        {displayElements.includes("icon") && (
          <IconContainer>
            <Icon color={textColor[theme.name]} />
          </IconContainer>
        )}
        {displayElements.includes("title") ? (
          <Title clr={textColor[theme.name]}>
            <EditableText data={data} isEditable={isEditable} field="title" />
          </Title>
        ) : (
          <>
            {displayElements.includes("text") && (
              <Text clr={textColor[theme.name]} isTemplate={isTemplate}>
                <EditableText
                  data={data}
                  isEditable={isEditable}
                  field="text"
                />
              </Text>
            )}
          </>
        )}
      </IconTitleWrapper>

      {displayElements.includes("text") && displayElements.includes("title") && (
        <Text clr={textColor[theme.name]} isTemplate={isTemplate}>
          <EditableText data={data} isEditable={isEditable} field="text" />
        </Text>
      )}
    </Container>
  );
}

export default Standard;
